import "./assets/less/main.less";
import "./assets/less/uistruct.less";

import { createApp, ref } from "vue";
import App from "./App.vue";
import router from "./router";
import { startAnalytics } from "@/code/analytics";
import { Skapi } from "skapi-js";
import type {
    // BinaryFile,
    // Condition,
    // Connection,
    // ConnectionInfo,
    // DatabaseResponse,
    // DelRecordQuery,
    // FetchOptions,
    // FileInfo,
    // Form,
    // GetRecordQuery,
    // Index,
    // Newsletter,
    // PostRecordConfig,
    // ProgressCallback,
    // RealtimeCallback,
    // RecordData,
    // RTCConnector,
    // RTCConnectorParams,
    // RTCEvent,
    // RTCReceiverParams,
    // RTCResolved,
    // Subscription,
    // Table,
    // Tag,
    // UniqueId,
    // UserAttributes,
    UserProfile,
    // UserPublic,
    // WebSocketMessage,
} from "skapi-js";

import { initUser, userLoginCallback } from "./code/user";
import { initializeEndpoints } from "./code/endpoints";
import { installBackForwardRestore } from "./code/back-forward";
import { removeFullScreenLoader } from "./components/jsComponents";
import { version as APP_VERSION } from "../package.json";

let autoLogin = window.sessionStorage.getItem("dont_remember") !== "true";

const SERVICE_ID = import.meta.env.VITE_ADMIN;
const ETC_CONFIG = JSON.parse(import.meta.env.VITE_ETC);
let appMounted = false;

// build date
console.log("deploy:" + import.meta.env.VITE_DATE);
console.log("version:" + APP_VERSION);
// 이미 마운트된 앱이 있으면 먼저 언마운트
// HMR(Hot Module Replacement)로 인해 main.ts가 재로드될 때 새로운 앱 인스턴스가 생성되면서 기존에 마운트된 앱 위에 다시 마운트하려고 시도하는 문제를 방지
// 개발 환경에서 빌링 페이지 갔다가 브라우저 뒤로가기 했을 때 에러 발생 문제 해결
// Vue stamps the mounted app on its container; the DOM typings don't know it.
const existingApp = (
    document.querySelector("#app") as (Element & { __vue_app__?: { unmount(): void } }) | null
)?.__vue_app__;
if (existingApp) {
    existingApp.unmount();
}

export const app = createApp(App);

// Visits are counted from here on (src/code/analytics.ts).
startAnalytics(router);

let previousUserId = "";

export const onLoginHanger:{[id:string]: Function} = {}

// Published skapi-js version, interpolated into every code sample on the
// landing page. Starts as "latest" so `npm i skapi-js@latest` is a valid
// command even before (or without) the registry's answer.
export const npmVersion = ref("latest");

fetch("https://registry.npmjs.org/skapi-js/latest")
    .then((res) => res.json())
    .then((data) => {
        if (typeof data?.version === "string" && data.version) {
            npmVersion.value = data.version;
        }
    })
    .catch(() => { /* stays "latest" */ });

export const skapi = new Skapi(
    SERVICE_ID,
    "skapi",
    {
        requestBatchSize: 50,
        autoLogin,
        eventListener: {
            // onBatchProcess: (b) => console.log("Batch Process:", b),
            onUserUpdate: (user:UserProfile) => {
                initUser(user);
            },
            onLogin: async (user:UserProfile) => {
                // console.log("User logged in:", user);
                if (!user) {
                    skapi.util.terminatePendingRequests();
                }

                if (!appMounted) {
                    app.use(router);
                    app.mount("#app");

                    appMounted = true;
                }
                
                for(let k in onLoginHanger) {
                    try {
                        onLoginHanger[k](user);
                    } catch(err) {
                        console.error(`Error in onLoginHanger ${k}:`, err);
                    }
                    delete onLoginHanger[k];
                }

                if(previousUserId === (user?.user_id || "")) {
                    // console.log("Same user logged in, skipping onLogin callback.");
                    return;
                }

                previousUserId = user?.user_id || "";

                userLoginCallback(user);
            },
        },
    },
    ETC_CONFIG,
);

skapi.version();

initializeEndpoints(skapi);
// Back from the payment provider (or any other site) can restore this page from
// the back/forward cache as it was left, loader up: see code/back-forward.ts.
installBackForwardRestore({ removeLoader: removeFullScreenLoader });

import("./error_handler");

